// extracted by mini-css-extract-plugin
export default {"switchControl":"RawSwitch_switchControl__pK7ME"};